export default "__VITE_ASSET__DP6n9L2L__"